// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const selectAllBasicWarrantyEstimatorDealers = dealers => ({
    dealers,
    type: actions.SELECT_ALL_BASIC_WARRANTY_ESTIMATOR_DEALERS
});

export const selectBasicWarrantyEstimatorDealer = (dealer, isSelected) => ({
    dealer,
    isSelected,
    type: actions.SELECT_BASIC_WARRANTY_ESTIMATOR_DEALER
});

export const selectAllDealersOnLoad = dealers => ({
    dealers,
    type: actions.SELECT_ALL_BASIC_WARRANTY_ESTIMATOR_DEALERS_ON_LOAD
});



// WEBPACK FOOTER //
// ./src/reports/basic-warranty-estimator/action-creators/select-dealer.js